<template>
  <div
    class="flex flex-col w-full h-fit bg-white border border-grays-400 rounded"
  >
    <!-- Intro -->
    <div
      class="flex flex-col lg:flex-row w-full h-fit md:items-center pt-[22px] pl-[16px] pr-[20px] md:pr-[36px] lg:mb-[28px]"
    >
      <h3
        class="flex-1 text-xl font-medium text-primary-700 leading-[36px] items-center mb-[10px] lg:mb-0"
      >
        כרטיסי קנייה כארדכל
      </h3>
      <button-tooltip-hayadata
        :tooltipHayadataTexts="tooltipHayadataTexts"
        class="hidden md:flex"
      ></button-tooltip-hayadata>
    </div>
    <!-- cards -->
    <section
      v-for="card in cards"
      :key="card.id"
      class="lg:flex flex-row justify-between py-[11px] px-[20px] md:px-[60px] border-b border-grays-400"
    >
      <!-- Action part -->
      <div class="lg:flex flex-row gap-2 lg:gap-[76px]">
        <div class="flex w-[fit] items-center">
          <img
            alt="Visa"
            class="w-[111px] h-[28px] object-cover"
            src="/src/assets/icons/logos/Cardcol.svg"
          />
        </div>
        <div class="flex flex-row gap-[30px]">
          <div class="flex flex-none flex-col">
            <p class="text-sm font-medium text-grays-600">מספר כרטיס</p>
            <p class="text-base font-regular text-grays-900">
              {{ card.number }}
            </p>
          </div>
        </div>
      </div>
      <!-- Info part -->
      <div class="lg:flex flex-row justify-between items-center lg:gap-[97px]">
        <div class="flex flex-row gap-[24px]">
          <div
            class="flex flex-row justify-end items-center gap-[4px] text-error"
          >
            <span class="material-symbols-rounded text-base">sell</span>
            <p class="text-base font-regular">סכום נותר: ₪{{ card.balance }}</p>
          </div>
        </div>
        <button
          class="block w-full md:w-[28px] md:h-[28px] md:flex text-left justify-center items-center"
        >
          <span class="material-symbols-rounded text-grays-800 text-lg"
          @click="deleteCreditCard(card.id)"
            >delete</span
          >
        </button>
      </div>
      <button-tooltip-hayadata
        :tooltipHayadataTexts="tooltipHayadataTexts"
        class="flex md:hidden"
      ></button-tooltip-hayadata>
    </section>
    <!-- Save changes -->
    <div class="flex flex-col items-end py-[20px] px-[16px]">
      <button-secondary @click="addNewPrepaidCard">
        <span class="material-symbols-rounded text-lg">add_card</span>
        להוסיף כרטיס נטען
      </button-secondary>
    </div>
  </div>
</template>

<script>
import ButtonTooltipHayadata from "@/components/Global/ButtonTooltipHayadata.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";

export default {
  name: "add-prepaid-card",
  components: { ButtonSecondary, ButtonTooltipHayadata },
  props: {
    cards: {
      type: Array,
      default: [],
    },
  },
  emits: ["deleteCard", "addNewPrepaidCard"],
  data() {
    return {
      tooltipHayadataTexts: {
        title_bold: "הידעת? משלמים גם עם כרטיס נטען!",
        // title_regular: "!הידעת? משלמים גם עם כרטיס נטען",
        description:
          "אפשר לשלם במערכת גם עם כרטיסים נטענים שבהסדר (כמו נדרים או כארדכל) ולהוסיף כרטיס אשראי לגיבוי.\n" +
          "בסגירת ההזמנה המערכת גובה את התשלום מהכרטיס הנטען ובמקרה הצורך גובה את היתרה בכרטיס האשראי.",
      },
    };
  },
  methods: {
    async deleteCreditCard(id) {
      try {
        this.$emit("deleteCard", id);
      } catch (e) {
        console.error(e);
      }
    },
    addNewPrepaidCard() {
      this.$emit("addNewPrepaidCard", "oc");
    },
  },
};
</script>

<style>
</style>